<ion-header class="background-lightmimbo">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>PawHub</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-tabs>
    <ion-tab-bar slot="bottom" color="primary">
      <ion-tab-button tab="articles">
        <ion-icon name="reader-outline"></ion-icon>
        <ion-label>Articles</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="dailyfact">
        <ion-icon name="information-circle-outline"></ion-icon>
        <ion-label>Daily Fact</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="behavior">
        <ion-icon name="language-outline"></ion-icon>
        <ion-label>FurSignals</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</ion-content>